import React from "react";
import { number, oneOfType, string, func, arrayOf, bool, shape } from "prop-types";
import CircleInfoSolidV6 from "@shared/v2/Icomoon/Icons/CircleInfoSolidV6";
import Toggle from "@shared/v2/Toggle";
import Dropdown from "@shared/v2/Dropdown";
import Tooltip from "@shared/v2/Tooltip";
import ResultsBanner from "./ResultsBanner";

const CreateReports = ({
  selectedLeads,
  country,
  marketReportCount,
  homeValueReportCount,
  handlePropertyTypeChange,
  propertyTypes,
  selectedPropertyType,
  handleDripFrequencyChange,
  handleSearchRadiusChange,
  searchRadius,
  selectedSearchRadius,
  ContactAddresses,
  selectedContactAddress,
  handleContactAddressChange,
  dripFrequency,
  selectedDripFrequency,
  handleHVToggleChange,
  isToggleON,
}) => (
  <div>
    <ResultsBanner
      isToggleON={isToggleON}
      homeValueReportCount={homeValueReportCount}
      totalLeads={selectedLeads.length}
      count={marketReportCount}
      isCreate
      country={country}
    />

    <div className="tw-grid tw-grid-cols-2 tw-gap-[24px]">
      <div className="tw-mb-[15px]">
        <Dropdown
          isDisabled
          label="Contact Address Type"
          isClearable={false}
          name="contactAddressType"
          onChange={handleContactAddressChange}
          options={ContactAddresses}
          placeholder="Property Types"
          value={ContactAddresses.find((t) => t.value === selectedContactAddress)}
        />
      </div>

      <div className="tw-mb-[15px]">
        <Dropdown
          label="Property Type"
          isClearable={false}
          name="propertyType"
          onChange={handlePropertyTypeChange}
          options={propertyTypes}
          placeholder="Property Types"
          value={propertyTypes.find((t) => t.value === selectedPropertyType)}
        />
      </div>
    </div>
    <div className="tw-grid tw-grid-cols-2 tw-gap-[24px]">
      <div className="tw-mb-[15px]">
        <Dropdown
          label={
            <>
              Search Radius
              <Tooltip
                trigger={<CircleInfoSolidV6 size="m" className="tw-text-gray-75 tw-ml-[4px]" />}
                innerClassName="!tw-text-left tw-max-w-[180px]"
                content="Smart radius automatically expands the Market Report radius around the address until there are at least 15 search results, or you can manually set the search radius"
                placement="top"
              />
            </>
          }
          isClearable={false}
          name="searchRadius"
          onChange={handleSearchRadiusChange}
          options={searchRadius}
          placeholder="Search Radius"
          value={searchRadius.find((s) => s.value === selectedSearchRadius)}
        />
      </div>

      <div className="tw-mb-[15px]">
        <Dropdown
          label={
            <>
              Market Report Drip Frequency
              <Tooltip
                trigger={<CircleInfoSolidV6 size="m" className="tw-text-gray-75 tw-ml-[4px]" />}
                innerClassName="!tw-text-left tw-max-w-[180px]"
                content="How often the dynamic Market Report will be emailed to the contacts"
                placement="top"
              />
            </>
          }
          isClearable={false}
          name="dripFrequency"
          onChange={handleDripFrequencyChange}
          options={dripFrequency}
          placeholder="Drip Frequency"
          value={dripFrequency.find((d) => d.value === selectedDripFrequency)}
        />
      </div>
    </div>
    {country !== "canada" && (
      <div className="tw-pt-[9px]">
        <Toggle
          id="homeValue"
          name="homeValue"
          value={isToggleON}
          checked={isToggleON}
          onChange={handleHVToggleChange}
          textClassName="tw-font-semibold"
          text={
            <>
              Include Home Value in Market Report
              <Tooltip
                trigger={<CircleInfoSolidV6 size="m" className="tw-text-gray-75 tw-ml-[4px]" />}
                innerClassName="!tw-text-left tw-max-w-[180px]"
                content="Add a Home Value to share property valuation estimates in your Market Report. A valid street address is required. "
                placement="top"
              />
            </>
          }
        />
      </div>
    )}
  </div>
);
const optionsPropTypes = arrayOf(shape({ label: string, value: string }));

CreateReports.propTypes = {
  selectedLeads: arrayOf(oneOfType([number, string])),
  searchRadius: optionsPropTypes,
  ContactAddresses: optionsPropTypes,
  propertyTypes: optionsPropTypes,
  dripFrequency: optionsPropTypes,
  marketReportCount: number,
  homeValueReportCount: number,
  handlePropertyTypeChange: func,
  selectedPropertyType: string,
  handleDripFrequencyChange: func,
  handleSearchRadiusChange: func,
  selectedSearchRadius: string,
  selectedContactAddress: string,
  handleContactAddressChange: func,
  selectedDripFrequency: string,
  handleHVToggleChange: func,
  isToggleON: bool,
  country: string,
};

CreateReports.defaultProps = {
  selectedLeads: [],
  marketReportCount: 0,
  homeValueReportCount: 0,
  handlePropertyTypeChange: null,
  propertyTypes: [],
  selectedPropertyType: "",
  handleDripFrequencyChange: null,
  handleSearchRadiusChange: null,
  searchRadius: [],
  selectedSearchRadius: "0",
  ContactAddresses: [],
  selectedContactAddress: "home",
  handleContactAddressChange: null,
  dripFrequency: [],
  selectedDripFrequency: "every_2_weeks",
  handleHVToggleChange: null,
  isToggleON: false,
  country: "",
};

export default CreateReports;
